import React, { Component } from 'react';
import './style.scss';
import { I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { notify } from '../../../../Components/Notifier/services/actions';
import { deepEqual } from '../../utils';
import { Button, Icon, Tooltip } from '@material-ui/core';
import { getChildId } from '../../../../Components/MasterBar/service/saga';
import FilterNoneIcon from '@material-ui/icons/FilterNone';
import { getLinks } from '../../service/partnersLink/actions';

class ChildrenLink extends Component {
	componentDidMount() {
		if (
			this.props.connectAsMaster &&
			(!this.props.links || (this.props.links && !this.props.links.length))
		) {
			this.props.getPartnerLinks(this.props.prefix);
		}
	}

	copyToken = async value => {
		await navigator.clipboard.writeText(value);
		this.props.notify(I18n.t('partner.copied'), 'info');
	};

	render() {
		if (!this.props.connectAsMaster) return '';

		return (
			<div>
				<h2> {I18n.t('partner.master_link.title')}</h2>
				<table className="master_link">
					<tr className="master_link_header">
						<th>{I18n.t('partner.master_link.header_company')}</th>
						<th>{I18n.t('partner.master_link.header_id')}</th>
					</tr>

					{this.props.children.map(c => {
						const id =
							this.props.links && this.props.links[c.id_child]
								? this.props.links[c.id_child]
								: null;

						return (
							<tr className="master_link_row">
								<td>{c.company}</td>{' '}
								{id ? (
									<td className="linked" onClick={() => this.copyToken(id)}>
										{id}
										<FilterNoneIcon />
									</td>
								) : (
									<td>
										<Button
											color="primary"
											variant="contained"
											onClick={() =>
												this.props.onBoardingMaster(
													this.props.prefix,
													c.id_child
												)
											}>
											{I18n.t('partner.master_link.configure')}
										</Button>
									</td>
								)}
							</tr>
						);
					})}
				</table>
			</div>
		);
	}
}

const mapStateToProps = (state, props) => {
	const links = state.partnersLink[props.prefix];
	const connectAsMaster = state.service.user.children.length && !getChildId();
	return {
		partner: state.partners[props.prefix] || {},
		connectAsMaster,
		children: state.service.user.children,
		links,
	};
};

const mapDispatchToProps = dispatch => {
	return {
		notify: bindActionCreators(notify, dispatch),
		getPartnerLinks: prefix => dispatch(getLinks(prefix)),
		onBoardingMaster: (prefix, id_child) =>
			dispatch({
				type: 'ONBOARDING_MASTER',
				prefix,
				children: [id_child],
				refreshData: true,
			}),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(ChildrenLink);
